<template>
    <div class="my-border" :style="{ minHeight: screenHeight }">
        <section v-show="pageIsDisable == false" class="section">
            <div class="container-fluid">
                <div id="meeting-planner">
                    <img
                        v-if="loadingCompanies"
                        class="loading-companies"
                        src="../../../public/assets/img/preloader.gif"
                    />
                    <table
                        class="table pref-table"
                        v-if="!loadingCompanies"
                    >
                        <thead>
                            <tr>
                                <th class="fixed-header">
                                    Company
                                </th>
                                <th class="fixed-header">
                                    Meeting Type
                                </th>
                                <th class="fixed-header">
                                    Meeting Level
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(company, index) in data.companies"
                                v-bind:data-index="index"
                                v-bind:key="company.id + company.name"
                                class="group accordion-header accordion-header-active ui-state-active ui-corner-top"
                                :id="`company_id_${company.id}`"
                            >
                                <td class="data-row">
                                    <span
                                        :id="'tooltip_' + company.id"
                                        class="tooltip-content"
                                    >
                                        Presented By:
                                        <span
                                            style="display: block"
                                            v-for="(
                                                presenter, $index
                                            ) in company.presenter_names"
                                            :key="$index + Math.random()"
                                        >
                                            {{ presenter }}
                                        </span>
                                    </span>
                                    <span
                                        v-tooltip="{
                                            html: 'tooltip_' + company.id,
                                        }"
                                        >{{ company.name }}</span
                                    >
                                </td>
                                <td class="data-row">
                                    {{ company.preferences.meeting_type_readable }}
                                </td> 
                                <td class="data-row">
                                    {{ company.preferences.meeting_priority_readable }}
                                </td> 
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Api from "@/Api";
var _ = require("lodash");

export default {
    name: "ProfilePreferences",
    created() {
        $("#right").tooltip();
        $("#left").tooltip({
            placement: "left",
            title: "tooltip on left",
        });
    },
    data() {
        return {
            screenHeight: window.innerHeight + "px",
            loadingCompanies: false,
            pageIsDisable: false,
            data: {
                companies: [],
            },
            isLoading: false,
            client: JSON.parse(localStorage.getItem("client")).client,
        };
    },
    methods: {
        getData() {
            let auth = this.client;
            if (auth.client_type.type != 1) {
                this.pageIsDisable = true;
                this.error_message = "You dont have access to this page";
                return;
            }
            this.loadingCompanies = true;
            Api()
                .get("auth/preferences/client/companies?client_id=" + auth.id)
                .then((response) => {
                    this.loadingCompanies = false;
                    this.pageIsDisable = false;
                    let data = response.data;
                    this.data.companies = data.companies;
                })
                .catch((error) => {
                    this.loadingCompanies = false;
                    if (error) {
                        //debugger;
                        if (error.response.status == 422) {
                            this.pageIsDisable = true;
                            this.error_message = `
                                Please note that the meeting preference page is closed. For any further info, please contact
                                <a href="mailto:schedules@efg-hermes.com" >schedules@efg-hermes.com</a>
                            `;
                            var err = error.response.data;
                            this.errors = err.errors;
                        } else if (error.response.status == 401) {
                            this.$store.dispatch("logout");
                            this.$router.push({
                                name: "login",
                                query: {
                                    redirect:
                                        this.$router.currentRoute.fullPath,
                                },
                            });
                        }
                    }
                });
        },
    },
    mounted() {
        this.getData();
    },
};
</script>

<style>
.my-border {
    border: 1px solid #ddd;
    padding: 0.5rem;
}
.loading-companies {
    margin: auto;
    display: flex;
}
.fixed-header {
    text-align: left;
    position: sticky;
    top: 130px;
    z-index: 1;
    background-color: #004631;
    color: #fff;
}
.data-row { 
    text-align: left;
}
</style>
